export default __webpack_public_path__ + "static/edelwatt.uebersicht-3910d8dbb87341750d2dd5e2dbc45bf3.jpg";